import { PostOrPage } from '@tryghost/content-api';

import ContentBox from 'components/ContentBox';
import DateBox from 'components/DateBox';
import Tag from 'components/Tag';

import * as S from './styles';

interface IBlogPostHeader {
  post: PostOrPage;
  authors?: {
    name: string;
    image: {
      url: string;
    };
  }[];
  publishedAt?: string | null;
  tags?: {
    name?: string;
    slug: string;
  }[];
}

const BlogPostHeader = ({ post, authors, tags, publishedAt }: IBlogPostHeader) => {
  return (
    <ContentBox>
      <h1>{post.title}</h1>
      <S.NameAndDate>
        {authors?.map((author, i) => (
          <S.AuthorBox key={i}>
            <S.AuthorImage src={author.image.url} width='60' height='60' />
            <S.AuthorName>{author.name}</S.AuthorName>
          </S.AuthorBox>
        ))}
        {publishedAt && <DateBox date={publishedAt} showDay />}
      </S.NameAndDate>
      {tags && (
        <div>
          Categories:
          {tags.map((tag, i) => (
            <Tag tag={tag} key={i} />
          ))}
        </div>
      )}
    </ContentBox>
  );
};

export default BlogPostHeader;
